<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#165dff'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-org`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.25 11.3838C3.07849 11.3838 3.75 12.0554 3.75 12.8838C3.74993 13.7122 3.07845 14.3838 2.25 14.3838C1.42155 14.3838 0.750066 13.7122 0.75 12.8838C0.75 12.0554 1.42151 11.3838 2.25 11.3838ZM8 11.3838C8.8285 11.3838 9.5 12.0554 9.5 12.8838C9.4999 13.7121 8.82843 14.3838 8 14.3838C7.17157 14.3838 6.5001 13.7121 6.5 12.8838C6.5 12.0554 7.17151 11.3838 8 11.3838ZM13.75 11.3838C14.5785 11.3838 15.25 12.0554 15.25 12.8838C15.2499 13.7122 14.5785 14.3838 13.75 14.3838C12.9215 14.3838 12.2501 13.7122 12.25 12.8838C12.25 12.0554 12.9215 11.3838 13.75 11.3838ZM8.66504 6.5332H14.415V9.57812H13.085V7.86328H8.66504V9.57812H7.33496V7.86328H2.91504V9.57812H1.58496V6.5332H7.33496V4.625H8.66504V6.5332ZM8 0.400391C8.90267 0.400417 9.63477 1.13255 9.63477 2.03516C9.63457 2.93759 8.90255 3.66892 8 3.66895C7.09743 3.66895 6.36543 2.93761 6.36523 2.03516C6.36523 1.13254 7.09731 0.400391 8 0.400391Z"/></svg>
</template>
<script>

export default {
  name: 'IconColorOrg',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
